import { gql } from "@apollo/client";

export const QUERY_GET_MEDICAL_FIELDS = gql`
  query QUERY_GET_MEDICAL_FIELDS {
    enMedicalField {
      comment
      value
    }
  }
`